import { FC, useCallback, useState } from 'react';

import useToggle from '@hooks/useToggle';
import useRiskLevelDescriptions from '@store/hooks/useRiskLevelDescriptions';

import FormRiskLevelsControl from './FormRiskLevelsControl/FormRiskLevelsControl';
import FormRiskLevelsModal from './FormRiskLevelsModal/FormRiskLevelsModal';
import { IFormRiskLevelsProps, IFormRiskLevelValue } from './FormRiskLevels.interface';
import { updateRiskLevels } from './utils';

const FormRiskLevels: FC<IFormRiskLevelsProps> = ({
  className,
  input: { value = [], onChange },
}) => {
  const descriptions = useRiskLevelDescriptions();

  const [isModalOpen, handleOpenModal, handleCloseModal] = useToggle();
  const [currentItem, setCurrentItem] = useState<IFormRiskLevelValue>();

  const handleEdit = useCallback(
    (riskLevelId: number) => {
      const riskLevelDescriptionId = value.find(item => item.riskLevelId === riskLevelId)
        ?.riskLevelDescriptionId;
      setCurrentItem({ riskLevelId, riskLevelDescriptionId });
      handleOpenModal();
    },
    [value, handleOpenModal],
  );

  const handleSaveChanges = useCallback(
    ({ riskLevelId, riskLevelDescriptionId }: IFormRiskLevelValue) => {
      if (riskLevelDescriptionId) {
        onChange(updateRiskLevels(value, riskLevelId, riskLevelDescriptionId, descriptions));
      }
    },
    [value, descriptions, onChange],
  );

  const handleClear = useCallback(() => setCurrentItem(undefined), []);

  return (
    <>
      <FormRiskLevelsControl className={className} value={value} onEdit={handleEdit} />

      <FormRiskLevelsModal
        open={isModalOpen}
        options={descriptions}
        currentItem={currentItem}
        onClose={handleCloseModal}
        onExited={handleClear}
        onApply={handleSaveChanges}
      />
    </>
  );
};

export default FormRiskLevels;
